<template>
  <div :class="{'footer': pathInfo.indexOf('login') !== -1}">
    <el-container class="el-footer">
      <div class="footer-center">
        <div class="footer-lower">
          <span style="padding-top: 25px;">Copyright © 2023 Letsfly Limited. All rights reserved. | <a @click="gotoTc">Terms & Conditions</a></span>
          <span>Flat/RM 27, 10/F Cheung Tak Industrial Building, NO. 30 Wong Chuk Hang Road, Wong Chuk Hang, Hong Kong</span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
// import { getUserInfo, setUserCookie } from '@/request/user.js'
export default {
  name: 'publicFooter',
  props: ['source'],
  data () {
    return {
      qrCodePresale: '',
      qrCodePostsale: '',
      showTop: true,
      codeStyle: '',
      language: this.common.languageSet(this),
      aboutUsShow: false,
      bottomLine: 'unset',
      pathInfo: ''
    }
  },
  created: function () {
    this.aboutUsShow = true
    this.bottomLine = '1px solid #606266'
    this.pathInfo = this.$route.path
  },
  mounted () {
    // 悬浮框 PC端全部展示，手机端只有 首页 和 酒店列表页 展示
    var path = this.$route.path
    if (this.common.isMobile() === true && (path !== '/' && path.indexOf('HotelList') === -1)) {
      this.showTop = false
    }
    if (this.common.isMobile() === true) {
      var topRight = document.documentElement.clientWidth * 0.05 + 40
      this.codeStyle = 'right: ' + topRight + 'px; bottom: 10px;'
    }
  },
  methods: {
    toggleSlide: function (dom, bottom, time) {
      dom.style.transition = 'bottom ' + time + 's'
      if (bottom === 'inherit') {
        dom.style.bottom = '-500px'
      } else {
        dom.style.bottom = '-4px'
      }
    },
    gotoTop: function () {
      window.scrollTo({
        top: top,
        behavior: 'smooth'
      })
    },
    footerClick: function (type) {
      // 点击埋点 埋点记录
      this.clickPageAction(type, '', {'type': type})
    },
    gotoTc: function () {
      var queryjson = {}
      if (this.source !== '' && this.source !== undefined && this.source !== null) {
        queryjson['source'] = this.source
      }
      let routeData = this.$router.resolve({name: 'termsAndConditions', query: queryjson})
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style scoped>
.footer-top .footer-link{color: #606266;text-decoration: none;}
.footer-top .el-divider--vertical{background: #606266;}
.footer-lower a{text-decoration: none;color: #606266; cursor: pointer;}
.footer-lower a:hover{text-decoration: underline;}
.footer-lower span{display: block;}
/deep/ .el-footer{padding: 0 !important;}
.footer .cookie-div{width: 100%;height: 25%;background: #71543D;background-color: rgba(79, 76, 76, 0.8);position: fixed;bottom: -500px;z-index: 201;padding: 1.1% 0px;color: white;font-size: 14px;}
.cookie-hide{display:none;}
.cookie-div .cookie-pc{margin: 0 auto;width: 1500px;height: 100%;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;
    font-weight: 400;}
.cookie-div .cookie-pc .cookie-left{width: 70%; height: 100%; float: left;}
.cookie-div .cookie-pc .cookie-left .cookie-top{width: 100%;height: 40%;/*line-height: 50px;*/line-height:3.5;}
.cookie-div .cookie-pc .cookie-left .cookie-bottom{width: 100%; height: 60%;}
.cookie-div .cookie-pc .cookie-right{width: 30%; height: 100%; float: right;text-align: right;}
.cookie-div .cookie-pc .cookie-right .cookie-top{width: 100%;height: 50%;/*line-height: 80px;*/line-height: 5.7;}
.cookie-div .cookie-pc .cookie-right .cookie-bottom{width: 100%; height: 50%;/*line-height: 50px;*/line-height: 3.5;}
.cookie-div .cookie-pc .cookie-right .dialog-accept{width: 130px;background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1);}
.cookie-div .cookie-pc .cookie-right .dialog-accept:hover{background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.cookie-div .cookie-pc .cookie-right .dialog-refuse{width: 130px;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.cookie-div .cookie-pc .cookie-right .dialog-refuse:hover{background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1); }

.cookie-div .cookie-mobile{margin: 0 auto;width: 90%;height: 100%;font-family: PingFangSCRegular, 'PingFang SC', sans-serif;
    font-weight: 400;}
.cookie-div .cookie-mobile .cookie-mobile-top{margin:10px 0px;width: 100%; height: 60%;}
.cookie-div .cookie-mobile .cookie-mobile-top .cookie-top{margin-bottom: 20px;}
.cookie-div .cookie-mobile .cookie-mobile-bottom{margin:10px 0px;width: 100%; height: 40%;}

.cookie-div .cookie-mobile .cookie-mobile-bottom .cookie-left{width: 50%;height: 100%;float: left;text-align: center;margin: 15px 0px;}
.cookie-div .cookie-mobile .cookie-mobile-bottom .cookie-right{width: 50%; height: 100%;float: right;text-align: center;margin: 15px 0px;}
.cookie-div .cookie-mobile .cookie-mobile-bottom .dialog-accept{width: 98%;float:right;height: 35px;background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1);}
.cookie-div .cookie-mobile .cookie-mobile-bottom .dialog-accept:hover{background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.cookie-div .cookie-mobile .cookie-mobile-bottom .dialog-refuse{width: 98%;height: 35px;background-color: #333;border: 1px solid #333;border-radius: 4px;font-weight: 500;font-size: 14px;color: #FFFFFF;}
.cookie-div .cookie-mobile .cookie-mobile-bottom .dialog-refuse:hover{background-color: rgb(252, 210, 5, 1); color:#4F4C4C;border-color: rgb(252, 210, 5, 1); }
.cookie-div .cookie-mobile .cookie-mobile-bottom /deep/ .el-button{padding: 10px 20px;}
.mainMask{position: fixed; top: 0px;left: 0px;width: 100%;height: 100%;background: rgb(0,0,0,0.4);z-index: 2000;}

.qrcode-pc{width:100px !important; height: 232px !important;position: fixed; right: 80px;bottom: 40px;z-index: 2001; background-color: #fff; font-size: 12px; padding: 10px 5px; text-align: center;}
.sec-top{height: auto; width: 40px; background: inherit; box-shadow: none; text-align: center; line-height: 40px; background-color: #fff; position: fixed; right: 40px; bottom: 40px; border: none; border-radius: 20px 20px 20px 20px; opacity: 0.9;box-shadow: 0 0 6px rgb(0 0 0 / 12%);z-index: 201;}
.sec-top-mobile{right: 5%; bottom: 10px;}

.sec-top div{width:40px;height:40px; cursor: pointer;}
.sec-top .service:hover{ border: none;border-radius: 20px 20px 0 0;background: inherit;  background-color: #5392F9; border: none;-moz-box-shadow: none; -webkit-box-shadow: none;box-shadow: none;}
.sec-top .code:hover{border: none;background: inherit;  background-color: #5392F9; border: none;-moz-box-shadow: none; -webkit-box-shadow: none;box-shadow: none;}
.sec-top .top:hover{border: none;background: inherit; border-radius: 0 0 20px 20px; background-color: #5392F9; border: none;-moz-box-shadow: none; -webkit-box-shadow: none;box-shadow: none;}
@media only screen and (min-width:1610px) {
  .cookie-div .cookie-pc .cookie-left .cookie-top{line-height: 5.5;}
  .cookie-div .cookie-pc .cookie-right .cookie-top{line-height: 9.7;}
}
</style>



// WEBPACK FOOTER //
// src/components/public/publicFooter.vue